import { render, staticRenderFns } from "./GroupsCrud.vue?vue&type=template&id=c8e0dd32"
import script from "./GroupsCrud.vue?vue&type=script&lang=js"
export * from "./GroupsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports